import useCommonApi from "../api/useCommonApi";
import {IRecoleccion} from "../redux/types/recoleccionActionTypes";
import {ICatalogo} from "../entities/catalogos/ICatalogo";
import {enums} from "../enums/enums";
import {ServicioAdicional} from "../entities/catalogos/ServicioAdicional";
import {Solicitud} from "../entities/solicitudes/Solicitud";

const useGetInformacionOrigenDestino = (cliente, updateServicios, saveTiposEnvio) => {
    const apiSource = useCommonApi();

    const combinarServicios = (recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion): ServicioAdicional[] => {
        let servicioAdicionales: ServicioAdicional[] = [];

        const serviciosOrigen = recoleccionOrigen.areaServicio?.serviciosAdicionales;
        const serviciosDestino = recoleccionDestino.areaServicio?.serviciosAdicionales;

        //Se agregan los servicios origen a la lista completa de servicios
        serviciosOrigen?.forEach(s => {
            const nuevoServicio = new ServicioAdicional(s);

            //Revisa si el servicio también aplica en el destino
            nuevoServicio.esDestino = !!serviciosDestino?.some(sd => sd.id === s.id);
            nuevoServicio.seleccionado = false;
            servicioAdicionales.push(nuevoServicio);
        });

        //Se configuran los servicios que van en la sección Servicios Adicionales correspondientes al destino
        serviciosDestino?.forEach(s => {
            const agregarCruce = !recoleccionOrigen.tieneCruceFronterizo || !s.nombre.includes("FLETE CRUCE FRONTERIZO");

            //Si el id ya esta agregado a los servicios adicionales ya no se agrega
            if (agregarCruce && !servicioAdicionales.some(e => e.id === s.id)) {
                const nuevoServicio = new ServicioAdicional(s);
                nuevoServicio.seleccionado = false;
                servicioAdicionales.push(new ServicioAdicional(nuevoServicio));
            }
        })

        return servicioAdicionales;
    }

    const obtenerConvenioServicios = async (solicitud: Solicitud, servicios: ServicioAdicional[]) => {
        const filtroConvenioServicios = {
            serviciosIds: servicios.map(e => e.id),
            clienteId: cliente.id,
            proyectoId: solicitud.proyecto?.id ?? 0,
            tipoServicioId: solicitud.tipoServicio?.id
        };

        return await apiSource.obtenerAsync("/convenio/convenios-servicios", filtroConvenioServicios);
    };

    const seleccionarServicios = (servicios: ServicioAdicional[], conveniosServicios, serviciosSeleccionados,
                                  esSeccionOrigen: boolean = false, esSeccionDestino: boolean = false) => {
        const clienteCredito: any = cliente.clienteCredito;

        servicios.forEach(s => {
            const convenioId = conveniosServicios.find(e => e.servicioId === s.id)?.convenioId ?? 0;
            const servicioSeleccionado = serviciosSeleccionados.find(ss => ss.concepto?.conceptoID === s.id);

            //Solo aplica para los servicios de la sección servicios adicionales
            if(!esSeccionOrigen && !esSeccionDestino){
                s.Configurar(convenioId);
            }

            if (servicioSeleccionado != null) {
                s.seleccionado = !esSeccionOrigen && !esSeccionDestino
                    || esSeccionOrigen && servicioSeleccionado.aplicaOrigen
                    || esSeccionDestino && servicioSeleccionado.aplicaDestino ;
                s.esOrigen = servicioSeleccionado.esOrigen;
                s.esDestino = servicioSeleccionado.esDestino;
                s.aplicaOrigen = servicioSeleccionado.aplicaOrigen;
                s.aplicaDestino = servicioSeleccionado.aplicaDestino;
                s.cantidadOrigen = servicioSeleccionado.cantidadOrigen;
                s.cantidadDestino = servicioSeleccionado.cantidadDestino;
                s.cantidad = servicioSeleccionado.cantidad;
            }
        })

        if (clienteCredito && clienteCredito.tipoPagoID === 1) {
            const index = servicios.findIndex(o => o.nombre === 'COBRO EN DESTINO');

            if(index >= 0){
                servicios.splice(index, 1);
            }
        }
    }

    return {
        getTipoServicio: async (recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion) => {
            const esOcurreOrigen = recoleccionOrigen.tipoRecoleccionId === enums.tipoRecoleccion.ocurre;
            const esOcurreDestino = recoleccionDestino.tipoRecoleccionId === enums.tipoRecoleccion.ocurre;
            const filter = {
                clienteId: cliente.id,
                areaServicioOrigenId: recoleccionOrigen.areaServicio?.id,
                areaServicioDestinoId: recoleccionDestino.areaServicio?.id,
                esOcurreOrigen,
                esOcurreDestino,
                origenPaisId: recoleccionOrigen.paisId,
                destinoPaisId: recoleccionDestino.paisId,
            };

            const result = await apiSource.obtenerAsync<any>("tipo-envio/by-cliente-ruta", filter);
            const tipoServicio: ICatalogo = result.tipoServicio;
            saveTiposEnvio(result.tiposEnvio ? result.tiposEnvio : result);

            return tipoServicio;
        },
        saveServicioAdicionales: async (recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion,
                                        solicitud: Solicitud, esSeleccionarServicios: boolean = false) => {
            const serviciosSeleccionados = solicitud.serviciosAdicionales ?? [];
            let servicioAdicionales = combinarServicios(recoleccionOrigen, recoleccionDestino);
            const conveniosServicios = await obtenerConvenioServicios(solicitud, servicioAdicionales);

            if(esSeleccionarServicios){

                seleccionarServicios(recoleccionOrigen.serviciosAdicionales ?? [], conveniosServicios,
                    serviciosSeleccionados, true, false);
                seleccionarServicios(recoleccionDestino.serviciosAdicionales ?? [], conveniosServicios,
                    serviciosSeleccionados, false, true);
            }

            seleccionarServicios(servicioAdicionales, conveniosServicios, serviciosSeleccionados);
            updateServicios(servicioAdicionales);
        },
        obtenerCoordenadas: async (distribuidor) => {
            const datos = {
                clienteId: distribuidor.clienteID,
                clienteDistribuidorId: distribuidor.clienteDistribuidorID
            };
            const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-direccion/by-cliente-distribuidor", datos);

            return {
                id: distribuidor.clienteDistribuidorID,
                nombre: distribuidor.nombreClienteDistribuidor,
                clienteDistribuidorID: distribuidor.clienteDistribuidorID,
                colonia: distribuidor.colonium,
                codigoPostal: distribuidor.codigoPostal,
                paisId: distribuidor.paisID,
                estadoId: distribuidor.estadoID,
                ciudadId: distribuidor.ciudadID,
                clienteID: distribuidor.clienteID,
                latitude: result.latitudVerificada,
                longitude: result.longitudVerificada
            }
        }
    }
}

export default useGetInformacionOrigenDestino;
